import React from "react";
import ContactOneInfoItem from "./ContactOneInfoItem";

const ContactOne = () => {
  const info_items = [
    {
      icon: "fa-envelope",
      content: (
        <a href="mailto:contato@usystech.com.br" className="contact-link">
          contato@usystech.com.br
        </a>
      ),
    },
    {
      icon: "fa-phone",
      content: (
        <a href="tel:+554796704516" className="contact-link">
          +55 47 9670-4516
        </a>
      ),
    },
    {
      icon: "fa-map-marker-alt",
      content: (
        <>
          Rua 15 DE NOVEMBRO, 550, SALA 404 <br />Blumenau - SC
        </>
      ),
    },
  ];

  return (
    <section id="contact" className="contact-area pt-70 pb-110">
      <div className="container">
        {/* section title */}
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-title text-center mb-70">
              <span className="sub-title">Contato</span>
              <h2 className="title">
                <span>Contato </span> USYS
              </h2>
            </div>
          </div>
        </div>

        {/* contact info - aligned and centered */}
        <div className="contact-info-wrap contact-info-only">
          <div className="row justify-content-center align-items-stretch g-4">
            {info_items.map((x, index) => (
              <div key={index} className="col-lg-4 col-md-6">
                <ContactOneInfoItem item={x} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactOne;
